var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoggy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:8px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "foggy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "foggy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.36,123H181.9c3.87,0,18.26-1.84,15.77-19.09C193.8,77,167.24,86.16,167.24,86.16s6-14.85-8-26.29c-18.26-14.94-32.65-2.49-32.65-2.49s-4.15-19.65-32.93-17.71C62.86,41.75,63.74,65.13,63.74,65.13a20.34,20.34,0,0,0-24.63-1.66C24.6,72.47,28.6,85.33,28.6,85.33S6.73,83.13,2.87,100.28C-1.29,118.7,11.17,123,18.36,123Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 163.81,
    y1: 156.46,
    x2: 121.3,
    y2: 156.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 107.5,
    y1: 156.46,
    x2: 36.83,
    y2: 156.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.3,
    y1: 137.41,
    x2: 76.19,
    y2: 137.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 92.07,
    y1: 137.41,
    x2: 173.34,
    y2: 137.41
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoggy);
export default __webpack_public_path__ + "static/media/foggy.0a0bd08cc4ffe45bc3f15497f5269a1e.svg";
export { ForwardRef as ReactComponent };